import { actionFactory, typeFactory } from 'common/store/scope';

import { actions as resourceActions } from '../resource';
import { actions as searchActions } from '../search';

export const TOGGLE_SORT = 'TOGGLE_SORT';
export const PAGINATION_CHANGE = 'PAGINATION_CHANGE';
export const SEARCH = 'SEARCH';
export const ADVANCED_SEARCH = 'ADVANCED_SEARCH';
export const DOWNLOAD = 'DOWNLOAD';
export const DOWNLOAD_INPROGRESS = 'DOWNLOAD_INPROGRESS';
export const DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS';
export const DOWNLOAD_ERROR = 'DOWNLOAD_ERROR';

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  UPDATE,
  CLEAR,
  loadError,
  update,
  clear,
} = resourceActions;

export const load = ({
  limit,
  offset,
  sort,
  query,
} = {}) => ({
  ...resourceActions.load({ clear: true }),
  limit,
  offset,
  sort,
  query,
});

export const loadSuccess = ({ data, total }) => ({
  ...resourceActions.loadSuccess(data),
  items: data,
  total,
});

export const toggleSort = property => ({
  type: TOGGLE_SORT,
  property,
});

export const paginationChange = ({ limit, offset }) => ({
  type: PAGINATION_CHANGE,
  limit,
  offset,
});

export const download = ({
  sort,
  query,
} = {}) => ({
  type: DOWNLOAD,
  sort,
  query,
});

export const downloadSuccess = ({ data, total }) => ({
  type: DOWNLOAD_SUCCESS,
  blob: data,
  total,
});

export const downloadError = error => ({
  type: DOWNLOAD_ERROR,
  error,
});

export const factory = (namespace) => {
  const resource = resourceActions.factory(namespace);
  const search = searchActions.factory(namespace);

  return {
    ...resource,
    ...search,
    ...actionFactory(namespace, {
      load,
      loadSuccess,
      toggleSort,
      paginationChange,
      download,
      downloadSuccess,
      downloadError,
    }),
    TYPES: {
      ...resource.TYPES,
      ...search.TYPES,
      ...typeFactory(namespace, {
        TOGGLE_SORT,
        PAGINATION_CHANGE,
        SEARCH,
        DOWNLOAD,
        DOWNLOAD_SUCCESS,
        DOWNLOAD_ERROR,
      }),
    },
  };
};

export default factory;
